module.exports = "/shared/img/send-message.svg";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/send-message.svg
// module id = 449
// module chunks = 13